<div class="sortable-holder">
  <!--[sortablejs]="assignments" [sortablejsOptions]="sortConfig"-->
  <div *ngFor="let a of assignments; let i= index">
    <div class="drop-area__item draggable-item">
      <rl-assignment-brief [assignment]="a" [mode]="mode ? 'edit' : 'full'" (onDelete)="removeAssignment(i)" class="rl-citation-item assignment-brief"></rl-assignment-brief>
    </div>
    <rl-drag-handle class="item-drag-handler" [order]="a.order" [maxOrder]="assignments.length - 1" (orderChange)="updateOrder(i, $event)"></rl-drag-handle>
    <div *ngIf="mode=='multiSelect'" tabindex="0">
      <span class="normal-cb">
        <label [for]="'assignment-checkbox-' + a.id" class="sr-only">Select assignment: {{a.title}}</label>
        <input [id]="'assignment-checkbox-' + a.id" type="checkbox" [value]="a.id" tabindex="0" (change)="handleMultiSelect(a)" [(ngModel)]="a.selected">
      </span>
    </div>
    <div *ngIf="mode=='select'">
      <span class="normal-rb">
        <label [for]="'assignment-radio-' + a.id" class="sr-only">Select assignment: {{a.title}}</label>
        <input [id]="'assignment-radio-' + a.id" type="radio" [value]="a.id" tabindex="0" (change)="onSelectChange.emit(selectedAsgmt)" [(ngModel)]="selectedAsgmt" tabindex="0">
      </span>
    </div>
  </div>
</div>